<template>
  <div v-show="productTypeData?.productTypes?.data.length !== 0">
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <BreadCrumbs
            class="col-span-6 col-start-1 text-lg uppercase leading-[1.2] tracking-[0.08em] text-ng70 laptop:col-span-10 laptop:col-start-2 laptop:text-xl laptop:leading-[1.7]"
          />
          <h1
            class="col-span-6 col-start-1 mt-1 text-lg leading-[1.4] laptop:col-span-7 laptop:col-start-2 laptop:text-[32px] laptop:leading-[1.7]"
          >
            <span class="">{{ productTypeData?.productTypes?.data[0]?.attributes?.page_title }}</span>
          </h1>
          <p class="subtitle col-span-5 laptop:col-span-3 laptop:col-start-2">
            {{ productTypeData?.productsProductTypePage?.data?.attributes?.hero_subtitle }}
          </p>
          <div
            class="col-span-5 mt-2 flex laptop:col-span-3 laptop:col-end-12 laptop:mt-12 laptop:justify-end desktop:mt-0"
          >
            <!--            {{ productTypeData?.productTypes?.data[0]?.attributes?.brochure?.data?.attributes?.url }}-->
            <DownloadBtn
              class="laptop:self-end"
              :text="$t('download-type-brochure')"
              :href="productTypeData?.productTypes?.data[0]?.attributes?.brochure?.data?.attributes?.url"
              v-if="productTypeData?.productTypes?.data[0]?.attributes?.brochure?.data?.attributes?.url"
            />
          </div>
        </div>
        <div
          class="grid-wrapper mt-14 grid grid-cols-6 gap-y-10 gap-x-6 tablet:mt-[100px] laptop:mt-14 laptop:grid-cols-12 laptop:gap-y-12 laptop:gap-y-[100px]"
        >
          <BrandsVariety
            v-for="(variety, index) in productTypeData?.productTypes?.data[0]?.attributes?.product_type_options?.data"
            :key="JSON.stringify(variety)"
            class="order-1 col-span-3 mt-0"
            :class="{
              'col-start-1 laptop:col-start-2 laptop:ml-4': index % 5 === 0,
              'col-start-4 laptop:col-start-5 laptop:ml-12': index % 5 === 1,
              'col-start-1  row-start-2 mt-0 laptop:col-start-7': index % 5 === 2,
              'col-start-4 row-start-2 mt-0 laptop:col-start-10': index % 5 === 3,
            }"
            :image="variety?.attributes?.icon?.data?.attributes?.url || ''"
            :alt="variety?.attributes?.icon?.data?.attributes?.alternativeText || ''"
            :area="variety?.attributes?.name || ''"
            :to="
              localePath({
                name: 'products-type-subtype',
                params: { type: route.params.type as string, subtype: variety?.attributes?.slug as string },
              })
            "
          />

          <p
            v-if="
              productTypeData?.productTypes?.data[0]?.attributes?.product_type_options?.data &&
              productTypeData?.productTypes?.data[0]?.attributes?.product_type_options?.data?.length > 0
            "
            class="order-5 col-span-6 self-end laptop:order-3 laptop:col-span-3 laptop:col-start-9"
          >
            {{ productTypeData?.productTypes?.data[0]?.attributes?.hero_paragraph_1 }}
          </p>
          <p
            v-if="
              productTypeData?.productTypes?.data[0]?.attributes?.product_type_options?.data &&
              productTypeData?.productTypes?.data[0]?.attributes?.product_type_options?.data?.length > 2
            "
            class="order-6 col-span-6 self-end laptop:order-4 laptop:col-span-3 laptop:col-start-3"
          >
            {{ productTypeData?.productTypes?.data[0]?.attributes?.hero_paragraph_2 }}
          </p>
        </div>
      </SectionSet>
      <SectionSet v-if="productCuts && productCuts.length">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2
            class="col-span-4 col-start-3 mb-8 flex justify-end text-right laptop:col-start-8 laptop:col-end-12 laptop:mb-10"
          >
            {{ productTypeData?.productsProductTypePage?.data?.attributes?.cuts_title }}
          </h2>
          <div
            class="flex laptop:justify-between laptop:items-end flex-wrap col-span-6 laptop:col-span-10 laptop:col-start-2"
          >
            <ProductTypeVariations
              v-for="(variation, index) in productCuts"
              :key="JSON.stringify(variation)"
              class="col-span-3 laptop:col-span-2 laptop:col-start-2 laptop:w-[20%] w-[50%]"
              :class="`col-start-${1 + 3 * (index % 2)} laptop:col-start-${2 + 2 * (index % 5)}`"
              :variation="variation?.attributes?.name || ''"
              :image="variation?.image?.url"
            />
          </div>
        </div>
      </SectionSet>
      <SectionSet v-if="['olives', 'elies'].includes(productTypeData?.productTypes?.data[0]?.attributes?.slug)">
        <div class="laptop:block">
          <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
            <h2 class="col-span-5 mb-8 flex laptop:col-span-5 laptop:col-start-2 laptop:mb-10">
              {{ productTypeData?.productsProductTypePage?.data?.attributes?.extras_title }}
            </h2>
            <div class="col-span-6 col-start-1 -m-2 justify-center laptop:col-span-10 laptop:col-start-2">
              <OliveIngredients />
              <!--              <div
                v-for="(ingredient, index) in ingredients"
                :key="ingredient.image"
                class="m-2 flex h-[109px] flex-[_0_1_20%] justify-center laptop:h-[210px]"
                :class="{
                  'laptop:flex-[_0_1_11.191%] ': index < 7,
                  'laptop:flex-[_0_1_11.4%] ': index >= 7,
                }"
              >
                <img
                  :src="ingredient.image"
                  class="max-h-[62px] max-w-[62px] object-contain laptop:max-h-[210px] laptop:max-w-[120px]"
                  :title="ingredient.name"
                  :class="{
                    'self-center': index % 2 === 0,
                    'self-end': index % 2 === 1,
                  }"
                />
              </div>-->
            </div>
          </div>
        </div>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 mt-8 flex justify-end laptop:col-span-4 laptop:col-end-12 laptop:mt-10">
            <NextBtn
              type="button"
              :text="$t('Pick a variety to see Available Options')"
              @click="scrollToTop()"
              :isRotated="true"
            />
          </div>
        </div>
      </SectionSet>
      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 flex flex-col laptop:col-span-10 laptop:col-start-2">
            <h2 class="text-right capitalize laptop:text-right">
              {{ $t("in") }}
              <HighlightedLink :to="{ name: 'for-business' }" class="link px-0">
                <span class="underlined relative leading-[1.2]"> {{ $t("packagings") }} </span>
              </HighlightedLink>
              {{ $t("thatsuitsyourneeds") }}
            </h2>
            <NuxtLink
              :to="localePath({ name: 'products-packaging' })"
              :aria-label="productTypeData?.productsProductTypePage?.data?.attributes?.packaging_title"
            >
              <img
                class="mt-12 laptop:mt-[56px]"
                src="/images/packages.png"
                :alt="productTypeData?.productsProductTypePage?.data?.attributes?.packaging_title || 'Packaging'"
              />
            </NuxtLink>
          </div>
          <div
            class="col-span-6 mt-8 flex flex-col gap-y-4 text-center laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex-row laptop:justify-between laptop:gap-y-0"
          >
            <h3>{{ productTypeData?.productsProductTypePage?.data?.attributes?.packaging_options[0]?.title }}</h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>{{ productTypeData?.productsProductTypePage?.data?.attributes?.packaging_options[1]?.title }}</h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>{{ productTypeData?.productsProductTypePage?.data?.attributes?.packaging_options[2]?.title }}</h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>{{ productTypeData?.productsProductTypePage?.data?.attributes?.packaging_options[3]?.title }}</h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>{{ productTypeData?.productsProductTypePage?.data?.attributes?.packaging_options[4]?.title }}</h3>
          </div>
          <div
            class="col-span-6 mt-8 flex flex-col items-center justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex-row"
          >
            <NextBtn
              class="col-span-6 laptop:col-span-3"
              :text="$t('learn-more-about-packaging-options')"
              :to="localePath({ name: 'products-packaging' })"
            />
            <div class="col-span-6 mt-3.5 laptop:col-span-3 laptop:col-start-9 laptop:justify-end">
              <DownloadBtn
                :text="$t('download-packaging-brochure')"
                :href="productTypeData?.productTypes?.data[0]?.attributes?.packaging_brochure?.data?.attributes?.url"
                v-if="productTypeData?.productTypes?.data[0]?.attributes?.packaging_brochure?.data?.attributes?.url"
              />
            </div>
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
    <!--    <SectionSet>
      <div class="flex flex-col">
        <CustomizationSection class="w-full" />
      </div>
    </SectionSet>-->
    <GridsOutterGrid>
      <SectionSet isLast class="col-span-3 col-start-1 laptop:col-span-1 laptop:col-start-2">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 col-start-1 laptop:col-span-10 laptop:col-start-2">
            <SliderBrands
              :products="productTypeData?.products?.data"
              :title="$t('take-a-look-at-pre-packaged')"
              :buttonText="$t('take-a-look-at-brands')"
              :link="localePath({ name: 'brands' })"
            />
          </div>
        </div>
      </SectionSet>
    </GridsOutterGrid>
  </div>
</template>
<script setup lang="ts">
import { generateDynamicTitle } from "~~/utilities/dynamic-title";
import { LoadingBarKey } from "~/symbols/symbols";
import { scrollToTop } from "~/utilities/utils";

const loadingBarIndicator = inject(LoadingBarKey);

definePageMeta({
  validate: async (route) => {
    if (route.params.type === undefined) return false;
    const nuxt = useNuxtApp();
    const { data } = await useAsyncGql({
      operation: "CheckIfProductTypeExists",
      variables: { locale: nuxt.$i18n.locale.value, slug: route.params.type as string },
      options: {
        lazy: true,
      },
    });
    if (data?.value?.productTypes?.data.length === 0) {
      return false;
    } else {
      return true;
    }
  },
});

const genericCutCategory = "conservoelia-green-olives";

const route = useRoute();
const { t: $t } = useI18n();

const localePath = useLocalePath();

const { locale, finalizePendingLocaleChange } = useI18n();

await finalizePendingLocaleChange();

loadingBarIndicator?.value?.indicator?.start();
const { data: productTypeData } = await useAsyncGql({
  operation: "GetProductTypePageData",
  variables: { locale: locale.value, product_type: route.params.type as string },
  options: {
    lazy: false,
  },
});

const title = generateDynamicTitle(route);
useHead({
  title: `${title}`,
});

useServerSeoMeta({
  title: () => `${title}`,
  ogTitle: () => `${title}`,
  description: () => "",
  ogDescription: () => "",
  ogImage: () => "",
});

if (productTypeData.value?.productTypes?.data.length === 0) {
  const router = useRouter();

  router.replace({ params: { type: productTypeData.value?.lozalized?.data[0].attributes?.slug as string } });
  loadingBarIndicator?.value?.indicator?.finish();
} else {
  loadingBarIndicator?.value?.indicator?.finish();
}

const { data: productTypeOptionCuts } = await useAsyncGql({
  operation: "GetProductTypeOptionsCuts",
  variables: { locale: locale.value, product_type: route.params.type as string },
  options: {
    lazy: false,
  },
});

const productCuts = computed(() => {
  const allCuts = productTypeOptionCuts.value?.productTypeOptions?.data.map((option) => {
    return option.attributes?.product_cuts?.data.flatMap((cut) => {
      return cut;
    });
  });

  const allCutsFlat = allCuts?.flatMap((cut) => {
    return cut;
  });

  const uniqueCuts = allCutsFlat?.filter((cut, index, self) => {
    return (
      index ===
      self.findIndex((t) => {
        return t?.attributes?.slug === cut?.attributes?.slug;
      })
    );
  });

  const uniqueCutsWithImages = uniqueCuts?.map((cut) => {
    const image = cut?.attributes?.image?.data.filter((image) => {
      return image?.attributes?.caption?.replace(/ /g, "").toLowerCase().split(",").includes(genericCutCategory);
    })[0];
    return {
      ...cut,
      image: {
        url: image?.attributes?.url,
        alt: image?.attributes?.alternativeText,
        caption: image?.attributes?.caption,
      },
    };
  });

  return uniqueCutsWithImages;
});

const ingredients = [
  {
    name: "peppers",
    image: "/images/ingredients/3w4vy0bw.png",
    alt: "peppers",
  },
  {
    name: "unknown",
    image: "/images/ingredients/7jupyndv.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/58bf1e2ae443f41d77c734ab.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/58bf1eade443f41d77c734ba.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/264ku2kc.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/10144972KG-20190726-Media-checkers515Wx515.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/Black-Pepper-High-Quality-PNG.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/fenne.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/garlic.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/hcy7tlix.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/ioqzo01upng",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/k2l668vd.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/kolios_tyri_ageladino-GI7ELRhF.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/lemon.png",
    alt: "",
  },
  {
    name: "unknown",
    image: "/images/ingredients/2.png",
    alt: "",
  },
];
</script>
